import React from "react";
import { Form, Input, Select, Checkbox, Icon, Button } from "antd";
import { Alert } from "antd";
import { Toggle } from "react-powerplug";

import { valuesAndErrorsToFields } from "../../shared/util/antdForm";

const { Option } = Select;

const UserForm = Form.create()(
  class extends React.Component {
    state = {
      formErrors: undefined,
    };

    handleSubmit = (e) => {
      const { form, onSubmit } = this.props;

      e.preventDefault();
      form.validateFields(async (err, values) => {
        if (err) {
          return;
        }

        const errors = await onSubmit(values);
        if (!errors) {
          return;
        }

        this.setState({ formErrors: errors["_errors"] });
        form.setFields(valuesAndErrorsToFields(values, errors));
      });
    };

    render() {
      const {
        row,
        licenseSet,
        loading,
        form: { getFieldDecorator },
      } = this.props;

      const { formErrors } = this.state;

      return (
        <Form onSubmit={this.handleSubmit} autoComplete="off" layout="vertical">
          {formErrors && (
            <Form.Item>
              {formErrors.map((error, index) => (
                <Alert
                  key={index}
                  message={error.toString()}
                  type="error"
                  showIcon
                />
              ))}
            </Form.Item>
          )}
          <Form.Item label="Username">
            {getFieldDecorator("username", {
              rules: [{ required: true, message: "Username is required" }],
              validateTrigger: ["onBlur"],
              initialValue: row.username,
            })(
              <Input
                type="text"
                placeholder="Please enter a username"
                prefix={<Icon type="user" />}
              />
            )}
          </Form.Item>

          {!row.id && (
            <Toggle initial={false}>
              {({ on, toggle }) => (
                <Form.Item label="Password">
                  {getFieldDecorator("password", {
                    rules: [
                      { required: true, message: "Password is required" },
                    ],
                    validateTrigger: ["onBlur"],
                  })(
                    <Input
                      type={on ? "text" : "password"}
                      placeholder="Please enter a password"
                      prefix={<Icon type="lock" />}
                      suffix={
                        <Icon
                          type={on ? "eye" : "eye-invisible"}
                          onClick={toggle}
                        />
                      }
                    />
                  )}
                </Form.Item>
              )}
            </Toggle>
          )}

          <Form.Item label="Email">
            {getFieldDecorator("email", {
              rules: [
                { required: true, message: "Email is required" },
                { type: "email", message: "Enter a valid email" },
              ],
              validateTrigger: ["onBlur"],
              initialValue: row.email,
            })(
              <Input
                type="email"
                placeholder="Please enter an email"
                prefix={<Icon type="mail" />}
              />
            )}
          </Form.Item>

          <Form.Item label="Mobile phone">
            {getFieldDecorator("mobilePhone", {
              initialValue: row.mobilePhone,
            })(
              <Input
                type="tel"
                placeholder="Please enter a mobile phone number"
                prefix={<Icon type="phone" />}
              />
            )}
          </Form.Item>

          <Form.Item label="Is admin?">
            {getFieldDecorator("isAdmin", {
              valuePropName: "checked",
              initialValue: row.isAdmin !== undefined ? row.isAdmin : false,
            })(
              <Checkbox>
                This user is an <strong>Admin</strong> user
              </Checkbox>
            )}
          </Form.Item>

          <Form.Item label="License">
            {getFieldDecorator("licenseId", {
              initialValue: row.licenseId,
            })(
              <Select placeholder="Select a license if applicable">
                <Option value={null}>---</Option>
                {licenseSet.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save
            </Button>
          </Form.Item>
        </Form>
      );
    }
  }
);

export default UserForm;
